import type { COLOR } from '@george-labs.com/design-system/types/utilsTS/color';

import type { Transaction } from '@shared/transactions-types';
import { getColorFromName } from '@shared/core-ui-layout';

import { useOwnerAccountForTransaction } from './useOwnerAccountForTransaction';

export function useTransactionColor(transaction: Transaction): COLOR | undefined {
    const account = useOwnerAccountForTransaction(transaction);
    return account ? getColorFromName(account.additionalData.color) : undefined;
}
